export default "__VITE_ASSET__BMDiqkFF__"